import React, { useEffect, useState, useCallback, useRef } from 'react';
import PostItem from './Post/post-item';
import queryString from 'query-string';
import useDidMountEffect from '../utils/useDidMountEffect';
import { connect, useDispatch } from 'react-redux';
import { appendFeed, fetchFeed, resetPosts } from '../../redux/actions';
import PostSkeleton from './Post/Skeleton';
import PThankYou from './PThankYou';
import { setPostThankyou } from '../../redux/actions/post';

const userInformation = JSON.parse(localStorage.getItem('user'));

const SUPostContents = ({
    posts,
    refetch = false,
    setRefetch,
    isSu = false,
    hasMore,
    isLoading,
    isReset,
    activePost,
    keyword,
    thankyou,
}) => {
    const dispatch = useDispatch();

    const [perPage, setPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);

    const observer = useRef();
    const lastPostElementRef = useCallback(node => {
        if (isLoading) {
            return false;
        };
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setCurrentPage(currentPage => currentPage + 1);
            }
        });

        if (node) observer.current.observe(node);
        return () => {
            observer.current.disconnect();
        };
    }, [isLoading, hasMore]);


    const getPosts = async (source = "onload") => {
        const parsed = queryString.parse(window.location.search);
        const params = {
            page: currentPage,
            per_page: perPage,
            post_id: parsed.postid,
            keyword
        };

        if (source === 'new') {
            setCurrentPage(1);
            dispatch(fetchFeed({
                ...params,
                page: 1
            }));
        } else {
            dispatch(appendFeed(params));
        }
    };

    useEffect(() => {
        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
            dispatch(resetPosts());
        };
    }, []);

    useDidMountEffect(() => {
        getPosts('new');
    }, [keyword]);

    useDidMountEffect(() => {
        if (refetch) {
            setCurrentPage(1);
            getPosts();
        }
    }, [refetch]);

    const handleLike = (index) => {
        const currentLike = !posts[index].is_liked_by_user;
        posts[index].is_liked_by_user = currentLike;

        if (currentLike === false) {
            const userIndex = posts[index].likes.findIndex(like => like.user_id == userInformation.id);
            posts[index].likes.splice(userIndex, 1);
        } else {
            posts[index].likes.push({ user_id: userInformation.id });
        }

        setPosts(
            [...posts],
            posts[index]
        );
    };

    useEffect(() => {
        if (posts.length > 0) {
            getPosts('loadMore');
        } else {
            getPosts();
        }
    }, [currentPage]);

    useEffect(() => {
        let mounted = true;

        // add timeout because axios blocks same request after cancellation
        if (isReset) {
            setTimeout(() => {
                getPosts();
            }, 1300);
        }

        return () => {
            mounted = false;
        };
    }, [isReset]);

    const handleThankyou = (payload) => {
        dispatch(setPostThankyou({ ...thankyou, show: payload }));
    };

    return (
        // <div className="mb-5 posts-list-container">
        <div className="posts-list-container">
            {
                thankyou.show
                    ? <PThankYou
                        show={thankyou.show}
                        pu={thankyou.pu}
                        setShow={handleThankyou}
                        isUpgrade={thankyou.upgrade}
                    />
                    : null
            }
            <div className="posts-list-wrapper" id="posts-list">
                {
                    posts.length > 0 && posts.map((post, index) => {
                        if (posts.length === index + (perPage - 2)) {
                            return <PostItem
                                ref={lastPostElementRef}
                                posts={posts}
                                post={post}
                                pu={post.user}
                                key={`${index}=${post.id}`}
                                likeHandler={handleLike}
                                index={index}
                                refetch={getPosts}
                                autoplay={false}
                            />;
                        } else {
                            return <PostItem
                                posts={posts}
                                post={post}
                                pu={post.user}
                                key={`${index}=${post.id}`}
                                likeHandler={handleLike}
                                index={index}
                                refetch={getPosts}
                                autoplay={false}
                            />;
                        }
                    })
                }

                {isLoading
                    ? <div className="text-center mt-4">
                        <PostSkeleton />
                    </div>
                    : null
                }

                {!isLoading && posts.length === 0
                    ? <div className="text-center mt-4">No posts found</div>
                    : null
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        posts: state.post.posts,
        hasMore: state.post.hasMore,
        isLoading: state.post.isLoading,
        activePost: state.post.selectedPost,
        isReset: state.post.is_reset,
        keyword: state.post.keyword,
        thankyou: state.post.thankyou,
    };
};

export default React.memo(connect(mapStateToProps)(SUPostContents));
